"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const arLocaleData = require("i18next-icu/locale-data/ar");
exports.default = arLocaleData;
//# sourceMappingURL=ar.js.map